/**
 *  ÉTLAP – közös segédek (backend/etkezes-etlap.js párja).
 *
 *  Az étlap egy sora: egy nap, egy menü-jel („A”, „B”) és az étel. A `menu` a párosított
 *  rendelhető menü azonosítója – ha a fájlbeli jelhez nem volt ilyen nevű menü, üres, és
 *  akkor a NÉV szerint keressük meg (ugyanazzal a kulccsal, amivel a kiszolgáló párosít).
 */
export interface EtlapSor {
  id: string;
  datum: string;            // ÉÉÉÉ-HH-NN
  nap?: string;
  menu_nev: string;
  leiras: string;
  menu: string | null;
  etkezes_helye: string | null;
  hely_nev?: string | null;
  menu_cim?: string | null;
}

/** Kisbetű, ékezet, idézőjel és a „menü” szó nélkül – „"A" Menü” = „A” = „a menü”. */
export function etlapNevKulcs(s: any): string {
  return String(s ?? '')
    .replace(/["'„”“«»‚‘’`]/g, ' ')
    .replace(/(?<!\p{L})men[üu](?!\p{L})/giu, ' ')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/\s+/g, ' ').trim();
}

/** Helyi idő szerinti ÉÉÉÉ-HH-NN (a toISOString UTC-ben számolna). */
export function helyiNap(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Az adott nap hetének hétfője (helyi idő). */
export function hetHetfoje(d: Date): Date {
  const h = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  h.setDate(h.getDate() - ((h.getDay() + 6) % 7));
  return h;
}

export function napHozzaad(d: Date, nap: number): Date {
  const u = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  u.setDate(u.getDate() + nap);
  return u;
}

/** Sorok napok szerint: { 'ÉÉÉÉ-HH-NN': EtlapSor[] }. */
export function etlapNaponta(sorok: EtlapSor[]): Record<string, EtlapSor[]> {
  const t: Record<string, EtlapSor[]> = {};
  for (const s of sorok || []) (t[s.datum] = t[s.datum] || []).push(s);
  return t;
}

/**
 *  Egy rendelhető menü étele az adott napon. Elsőként az azonosító dönt; ha a sor nincs
 *  menühöz kötve, a név – de csak akkor, ha a sor ugyanannak a beszállítónak szól (vagy
 *  beszállító nélküli), különben két beszállító „A” menüje összekeveredne.
 */
export function menuEtele(napSorai: EtlapSor[] | undefined, menuId: any, menuNev: any, helyId: any): string {
  const sorok = napSorai || [];
  if (!sorok.length) return '';
  const idSzerint = menuId ? sorok.find((s) => s.menu && String(s.menu) === String(menuId)) : null;
  if (idSzerint) return idSzerint.leiras;
  const kulcs = etlapNevKulcs(menuNev);
  if (!kulcs) return '';
  const nevSzerint = sorok.find((s) => !s.menu && etlapNevKulcs(s.menu_nev) === kulcs
    && (!s.etkezes_helye || !helyId || String(s.etkezes_helye) === String(helyId)));
  return nevSzerint?.leiras || '';
}
